export default __webpack_public_path__ + "static/media/residencial-eletroassist.a59b1140.png";